import React, { useState } from "react";
import CustomInput from "../../shared/CustomInput/CustomInput";
import CustomDropdown from "../../shared/CustomDropDown/CustomDropdown";
import { Box, Button } from "@mui/material";
import "./Distributeyourfilms.scss";
import UnifiedButton from "../../shared/Button";

function Distributeyourfilms() {
  const [contentType, setContentType] = useState("");
  const [genre, setGenre] = useState("");

  const contentTypes = [
    { label: "Select One", value: "" },
    { label: "Movie", value: "movie" },
    { label: "TV Show", value: "tv_show" },
    { label: "Web Series", value: "web_series" },
  ];

  const genres = [
    { label: "Select One", value: "" },
    { label: "Drama", value: "drama" },
    { label: "Comedy", value: "comedy" },
    { label: "Horror", value: "horror" },
  ];

  return (
    <Box className="legal-forms-second-section">
      <div className="form-row">
        <CustomInput
          label="First Name"
          placeholder="Enter your first name"
          fullWidth
        />
        <CustomInput
          label="Last Name"
          placeholder="Enter your last name"
          fullWidth
        />
      </div>

      <div className="form-row">
        <CustomInput label="Email" placeholder="Enter your email" fullWidth />
        <CustomInput
          label="Mobile no."
          placeholder="Enter your mobile number"
          fullWidth
        />
      </div>

      <div className="form-row">
        <CustomInput
          label="Web Series / TV Show / Movie Name"
          placeholder="Enter the name"
          fullWidth
        />
      </div>

      <div className="form-row">
        <CustomDropdown
          label="Type of Content?"
          value={contentType}
          onChange={(e) => setContentType(e.target.value)}
          options={contentTypes}
          placeholder="Select One"
        />
        <CustomInput
          label="Is the Content Already Released?"
          placeholder="Select any date"
          fullWidth
        />
      </div>

      <div className="form-row">
        <CustomDropdown
          label="Genre"
          value={genre}
          onChange={(e) => setGenre(e.target.value)}
          options={genres}
          placeholder="Select One"
        />
        <CustomInput
          label="No of Episodes (for Web Series)"
          placeholder="Select One"
          fullWidth
        />
      </div>

      <div className="form-row">
        <CustomInput
          label="Primary Language"
          placeholder="Enter primary language"
          fullWidth
        />
        <CustomInput
          label="Secondary Language (Dubbing)"
          placeholder="Enter secondary language"
          fullWidth
        />
      </div>
      <div className="form-row">
        <CustomInput
          label="Certification / Age Rating"
          placeholder="Enter certification or age rating"
          fullWidth
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <CustomInput
          label="Preview Link for Content (Make sure the file is unlocked)"
          placeholder="Enter the preview link"
          fullWidth
        />
      </div>

      <div className="form-row">
        <CustomInput
          label="Director/ Producer"
          placeholder="Enter Director or Producer"
          fullWidth
        />
        <CustomInput label="Actors" placeholder="Enter Actors" fullWidth />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <CustomInput
          label="Synopsis"
          placeholder="Tell Us.."
          fullWidth
          multiline
          rows={4}
        />
      </div>
      <div className="form-row">
        <CustomInput
          label="Attachments"
          placeholder="Click here for Attachment"
          fullWidth
        />
      </div>
      <Box
        sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <UnifiedButton
          className={"legal-form-button"}
          variant="contained"
          textContent={"Submit"}
          fullWidth
          sx={{ mt: 2, color: "white" }}
        />
      </Box>
    </Box>
  );
}

export default Distributeyourfilms;
